import React, { Component } from 'react';
import I18n from 'lib/i18n/i18n';
import { imageUrl, isMobile } from 'helpers/ApplicationHelper';
import PricingContent from "./pricingContent";
import {InfoAlert} from "@worthy-npm/clarity";


class Pricing extends Component{
    constructor(props){
        super(props)
    }

    render() {
        const mobile =  isMobile();
        const { estimations, id, diamondRange } = this.props
        let sumSubsets = Object.keys(estimations).filter(k => k != "Center Stone").reduce((total, obj) => estimations[obj] + total, 0)
        let range = `$${Math.round((diamondRange.low - sumSubsets)).toLocaleString('en')} - $${Math.round((diamondRange.high - sumSubsets)).toLocaleString('en')}`
        let setting = Math.round(estimations['Ring'] +
                                (estimations["Side Stone Batch"]? estimations["Side Stone Batch"]: 0) +
                                (estimations["Minor Stone Batch"]? estimations["Minor Stone Batch"]: 0)).toLocaleString('en')
        return (
            <div className="pricing" id={`graph${id}`}>
                <div className={'sub-title'}>{I18n.getString(`itemPage::trends::listingTrends::pricing::title`)}</div>
                <div className={'title'}>{I18n.getString(`itemPage::trends::listingTrends::pricing::mainTitle`)}</div>
                <div className={'diagram-wrapper'}>
                    <img src={imageUrl(`item/trends/${mobile ? 'mobile' : 'desktop'}_graph.svg`)}/>
                    <div className={`estimation ring-setting`}>${setting}</div>
                    <div className={`estimation center`}>{range}</div>
                    <div className={'legend'}> </div>
                </div>
                <div className={'alerts-section'}>
                    <InfoAlert text={I18n.getString('itemPage::trends::listingTrends::pricing::alert1')} canClose={false} />
                    <div className={'pricing-alert'} >
                        <InfoAlert text={I18n.getString('itemPage::trends::listingTrends::pricing::alert2')} canClose={false}/>
                    </div>
                </div>
                <div className={'content-section'}>
                    <div className={'title'}>{I18n.getString(`itemPage::trends::listingTrends::pricing::content::title`)}</div>
                    <div className={'sub-title'}>{I18n.getString(`itemPage::trends::listingTrends::pricing::content::subTitle`)}</div>
                    <div className={'content-parts'}>
                        <PricingContent section={'parts'}/>
                        <PricingContent section={'diamond'}/>
                        <PricingContent section={'scale'}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Pricing